import React from "react";
import { MultiSelect } from "primereact/multiselect";
import { FloatLabel } from "primereact/floatlabel";

interface Employee {
  id: number;
  name: string;
}

interface EmployeeSelectorProps {
  value: number[];
  onChange: (employeeIds: number[]) => void;
  employees: Employee[];
  disabled?: boolean;
  error?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  maxSelectedLabels?: number;
}

export const EmployeeSelector: React.FC<EmployeeSelectorProps> = ({
  value,
  onChange,
  employees,
  disabled = false,
  error,
  label = "Employees",
  placeholder = "Select employees",
  required = true,
  className = "",
  maxSelectedLabels = 3,
}) => {
  // Format employee options for multiselect
  const employeeOptions = employees.map((employee) => ({
    label: employee.name,
    value: employee.id,
  }));

  return (
    <div className="field">
      <FloatLabel>
        <MultiSelect
          id="employees"
          value={value}
          onChange={(e) => onChange(e.value)}
          options={employeeOptions}
          placeholder={placeholder}
          filter
          disabled={disabled}
          className={`w-full ${error ? "p-invalid" : ""} ${className}`}
          display="chip"
          maxSelectedLabels={maxSelectedLabels}
          filterInputAutoFocus
        />
        <label htmlFor="employees" className="block text-sm font-medium mb-2">
          {label} {required && "*"}
        </label>
      </FloatLabel>
      {error && <small className="p-error">{error}</small>}
    </div>
  );
};
